module.exports = __webpack_public_path__ + "media/images/benefit_goods-abd1080788cfc63c5bf739b710288744.png";